.connected.loading {
    display: inline;
}
.loading {
    height: 35px;
    fill: white;
    display: none;
}
